import React from 'react';
import {
  Grid,
  Checkbox,
  FormHelperText,
  Button,
  FormControlLabel
} from '@material-ui/core';
import { connect } from 'react-redux';
import Select from 'react-select';
import * as styles from './stepperStyle';
import { CompletedContext } from './StepperComponent';
import _ from 'lodash';
import { validate } from '../../../utils/validateInputs';

import UniqueRegisterSeriesInput from '../../Components/UniqueRegisterSeriesInput';
import DocSeriesInput from '../../Components/DocSeriesInputs/DocSeriesInput';
import DocNumberInput from '../../Components/DocNumberInputs/DocNumberInput';
import ActRecordNumberInput from '../../Components/ActRecordNumberInput';
import DateInput from '../../Components/DateInput';
import PersonalIdInput from '../../Components/PersonalInputs/PersonalIdInput';
import DocCenterInput from '../../Components/DocCenterInputs/DocCenterInput';

import { savePassport, apllicantData } from '../../../redux/actions/applicantAction';
import { createLoadingSelector } from '../../../redux/reducers/selectors';

const useCompleted = () => {
  const contextValue = React.useContext(CompletedContext);
  return contextValue;
};

function PassportData(props) {
  const [completed, dispatch] = useCompleted();

  const [submitted, setSubmitted] = React.useState(false);
  const handleChange = React.useCallback(
    _.debounce(q => props.handleApplicantChange(q), 500),
    []
  );

  const handleInputChange = e => {
    const { target } = e;
    // console.log(e.target.checked);

    handleChange(target);
  };

  const handleSelectChange = React.useCallback(
    name => select => {
      props.handleSelectApplicantChange(name, select);
    },
    []
  );

  const handleSavePassport = () => {
    const data = {
      id: props.application.id,
      sri: props.applicant.rnokpp,
      srirefusal: props.applicant.rnokpp_feature ? 1 : 0,
      documenttype: props.applicant.documenttype,
      documentserie: props.applicant.series,
      documentnumber: props.applicant.documentnumber,
      documentissued: props.applicant.dateofissue,
      documentissuer: props.applicant.issuedby,
      unzrNumber: props.applicant.unzrNumber,
      till: props.applicant.d_doc_stop
    };
    const newCompleted = completed;
    props
      .savePassport(data)
      .then(resp => {
        newCompleted[props.activeStep] = true;
        // props.setCompleted(newCompleted);
        // props.handleNext();
        dispatch({ type: 'COMPLETED', payload: newCompleted });
        props.apllicantData(props.application.id);
        props.handleNext()
      })
      .catch(err => {
        newCompleted[props.activeStep] = false;
      // props.setCompleted(newCompleted);
        dispatch({ type: 'COMPLETED', payload: newCompleted });
      });
  };

  const valid = validate(props.applicant, parseInt(props.applicant.documenttype));

  function completedDocs(applicant) {
    const doctype = parseInt(applicant.documenttype);
    switch (doctype) {
      case 1: // passport 1993
      case 4: // temporary doc
      case 99: // other doc
        return (
          !!valid.series &&
          !!valid.documentnumber &&
          !!applicant.issuedby &&
          !!valid.dateofissue
        );
      case 2: // passport 2016
        return (
          !!valid.documentnumber &&
          !!valid.d_doc_stop &&
          !!valid.dateofissue &&
          !!valid.unzr &&
          !!valid.issuedby
        );
      case 3: // child birth doc 2002
      case 5: // child birth doc 2010
        return (
          !!valid.series &&
          !!valid.documentnumber &&
          !!valid.actRecordNumber &&
          !!valid.actRecordDate &&
          !!valid.dateofissue &&
          !!applicant.issuedby
        );
      case 6: // child birth doc 2019
        return (
          !!valid.unzr &&
          !!valid.documentnumber &&
          !!valid.actRecordNumber &&
          !!valid.actRecordDate &&
          !!valid.dateofissue &&
          !!applicant.issuedby
        );

      default:
        return doctype;
    }
  }

  React.useEffect(() => {
    // const newCompleted = props.completed;
    setSubmitted(true);
    // const newCompleted = completed;

    if (completedDocs(props.applicant)) {
      // newCompleted[props.activeStep] = true;
      // // props.setCompleted(newCompleted);
      // // props.handleNext();
      // dispatch({ type: 'COMPLETED', payload: newCompleted });
    } else {
      // const newCompleted = props.completed;
      // newCompleted[props.activeStep] = false;
      // // props.setCompleted(newCompleted);
      // dispatch({ type: 'COMPLETED', payload: newCompleted });
    }
    // console.log(previousCompleted.current , props.completed[0]);
    // if (previousCompleted.current !== props.completed[0]) {
    //     props.setCompleted(newCompleted);
    //     previousCompleted.current = props.completed[0];
    // }
  }, [
    props.applicant.documenttype,
    props.applicant.unzrNumber,
    props.applicant.series,
    props.applicant.documentnumber,
    props.applicant.actRecordNumber,
    props.applicant.actRecordDate,
    props.applicant.dateofissue,
    props.applicant.d_doc_stop,
    props.applicant.issuedby,
    props.applicant.rnokpp
  ]);

  function handleCheck(e) {
    // console.log(e.target.checked);
    const { target } = e;
    props.handleApplicantChange(target);
  }

  return (
    <Grid container>
      <Grid container direction="row" spacing={2}>
        <Grid item xs={12} sm={6} md={4} lg={3}>
          <div className="form-item">
            <label htmlFor="documentType">Тип документу </label>{' '}
            <div className="selectWrapper">
              <Select
                //value={applicant.documenttype}
                value={props.directories.documentType.filter(
                  ({ value }) =>
                    value === parseInt(props.applicant.documenttype)
                )}
                onChange={handleSelectChange('documenttype')}
                name="documenttype"
                options={props.directories.documentType.filter(({value}) => [99, 1, 4, 99, 2].includes(value))}
                styles={styles.customStyles}
                placeholder=""
                // isLoading={
                //   props.isFatching.DATA_FROM_DIRECTORIES
                // }
                noOptionsMessage={() => 'помилка серверу'}
                className={
                  submitted && !props.applicant.documenttype && 'error'
                }
                menuPortalTarget={document.body}
                theme={styles.customTheme}
              />{' '}
              {submitted && !props.applicant.documenttype && (
                <FormHelperText error id="name-error-text">
                  {' '}
                  Поле обов 'язкове
                </FormHelperText>
              )}{' '}
            </div>{' '}
          </div>{' '}
        </Grid>
      </Grid>
      <Grid container direction="row" spacing={2}>
        <Grid
          item
          xs={12}
          sm={6}
          md={
            parseInt(props.applicant.documenttype) === 2 ||
            parseInt(props.applicant.documenttype) === 6
              ? 2
              : 1
          }
          lg={
            parseInt(props.applicant.documenttype) === 2 ||
            parseInt(props.applicant.documenttype) === 6
              ? 2
              : 1
          }
        >
          <div className="form-item">
            <label htmlFor="series">
              {' '}
              {parseInt(props.applicant.documenttype) === 2 ||
              parseInt(props.applicant.documenttype) === 6
                ? 'Номер УНЗР'
                : 'Серія'}{' '}
            </label>{' '}
            {parseInt(props.applicant.documenttype) === 2 ||
            parseInt(props.applicant.documenttype) === 6 ? (
              <>
                <UniqueRegisterSeriesInput
                  className={
                    parseInt(props.applicant.documenttype, 10) !== 99
                      ? submitted && !props.applicant.unzrNumber
                        ? 'error'
                        : ''
                      : ''
                  }
                  name="unzrNumber"
                  value={props.applicant.unzrNumber}
                  // doctype={applicant.documenttype}
                  maxLength={13}
                  type="text"
                  onChange={handleInputChange}
                />{' '}
                {!(submitted && !props.applicant.unzrNumber) &&
                  !valid.unzr && (
                    <FormHelperText error id="name-error-text">
                      {' '}
                      Не валідне значення поля
                    </FormHelperText>
                  )}{' '}
                {parseInt(props.applicant.documenttype) !== 99 &&
                  submitted &&
                  !props.applicant.unzrNumber && (
                    <FormHelperText error id="name-error-text">
                      {' '}
                      Поле обов 'язкове
                    </FormHelperText>
                  )}{' '}
              </>
            ) : (
              <>
                <DocSeriesInput
                  className={
                    // (parseInt(props.applicant.documenttype) !== 99)  
                    !([99, 4].some(item => item === parseInt(props.applicant.documenttype)))
                    // (parseInt(props.applicant.documenttype) !== 4)
                      ? submitted && !props.applicant.series
                        ? 'error'
                        : ''
                      : ''
                  }
                  name="series"
                  value={props.applicant.series}
                  doctype={props.applicant.documenttype}
                  type="text"
                  guide={false}
                  onChange={handleInputChange}
                />{' '}
                {!(submitted && !props.applicant.series) && !valid.series && (
                  <FormHelperText error id="name-error-text">
                    {' '}
                    Не валідне значення поля
                  </FormHelperText>
                )}{' '}
                {!([99, 4].some(item => item === parseInt(props.applicant.documenttype)))  &&
                  submitted &&
                  !props.applicant.series && (
                    <FormHelperText error id="name-error-text">
                      {' '}
                      Поле обов 'язкове
                    </FormHelperText>
                  )}{' '}
              </>
            )}
          </div>{' '}
        </Grid>
        <Grid item xs={12} sm={6} md={2} lg={2}>
          <div className="form-item">
            <label htmlFor="documentnumber">Номер документу </label>{' '}
            <DocNumberInput
              className={
                parseInt(props.applicant.documenttype) !== 99
                  ? submitted && !props.applicant.documentnumber
                    ? 'error'
                    : ''
                  : ''
              }
              name="documentnumber"
              value={props.applicant.documentnumber}
              doctype={props.applicant.documenttype}
              type="text"
              onChange={handleInputChange}
              guide={false}
            />{' '}
            {!(submitted && !props.applicant.documentnumber) &&
              !valid.documentnumber && (
                <FormHelperText error id="name-error-text">
                  {' '}
                  Не валідне значення поля
                </FormHelperText>
              )}{' '}
            {parseInt(props.applicant.documenttype) !== 99 &&
              submitted &&
              !props.applicant.documentnumber && (
                <FormHelperText error id="name-error-text">
                  {' '}
                  Поле обов 'язкове
                </FormHelperText>
              )}{' '}
          </div>{' '}
        </Grid>
        {(parseInt(props.applicant.documenttype, 10) === 3 ||
          parseInt(props.applicant.documenttype, 10) === 5 ||
          parseInt(props.applicant.documenttype, 10) === 6) && (
          <>
            <Grid item xs={12} sm={6} md={2} lg={2}>
              <div className="form-item">
                <label htmlFor="actRecordNumber">Номер актового запису </label>{' '}
                <ActRecordNumberInput
                  className={
                    parseInt(props.applicant.documenttype, 10) !== 99 &&
                    submitted &&
                    !props.applicant.actRecordNumber
                      ? 'error'
                      : ''
                  }
                  name="actRecordNumber"
                  value={props.applicant.actRecordNumber}
                  doctype={props.applicant.documenttype}
                  type="text"
                  onChange={handleInputChange}
                />{' '}
                {!(submitted && !props.applicant.actRecordNumber) &&
                  !valid.actRecordNumber && (
                    <FormHelperText error id="name-error-text">
                      {' '}
                      Не валідне значення поля
                    </FormHelperText>
                  )}{' '}
                {parseInt(props.applicant.documenttype, 10) !== 99 &&
                  submitted &&
                  !props.applicant.actRecordNumber && (
                    <FormHelperText error id="name-error-text">
                      Поле обов 'язкове{' '}
                    </FormHelperText>
                  )}{' '}
              </div>{' '}
            </Grid>

            <Grid item xs={12} sm={6} md={2} lg={2}>
              <div className="form-item">
                <label htmlFor="actRecordDate"> Дата актового запису </label>{' '}
                <DateInput
                  className={
                    parseInt(props.applicant.documenttype, 10) !== 99
                      ? submitted && !props.applicant.actRecordDate
                        ? 'error'
                        : ''
                      : ''
                  }
                  name="actRecordDate"
                  type="text"
                  value={props.applicant.actRecordDate}
                  onChange={handleInputChange}
                />{' '}
                {!(submitted && !props.applicant.actRecordDate) &&
                  !valid.actRecordDate && (
                    <FormHelperText error id="name-error-text">
                      {' '}
                      Не валідне значення поля
                    </FormHelperText>
                  )}{' '}
                {parseInt(props.applicant.documenttype, 10) !== 99 &&
                  submitted &&
                  !props.applicant.actRecordDate && (
                    <FormHelperText error id="name-error-text">
                      Поле обов 'язкове{' '}
                    </FormHelperText>
                  )}{' '}
              </div>{' '}
            </Grid>
          </>
        )}
        <Grid item xs={12} sm={6} md={2} lg={3}>
          <div className="form-item">
            <label htmlFor="dateofissue">Дата видачі документу </label>{' '}
            <DateInput
              className={
                parseInt(props.applicant.documenttype, 10) !== 99
                  ? submitted && !props.applicant.dateofissue
                    ? 'error'
                    : ''
                  : ''
              }
              name="dateofissue"
              type="text"
              value={props.applicant.dateofissue}
              onChange={handleInputChange}
            />{' '}
            {!(submitted && !props.applicant.dateofissue) &&
              !valid.dateofissue && (
                <FormHelperText error id="name-error-text">
                  {' '}
                  Не валідне значення поля
                </FormHelperText>
              )}{' '}
            {parseInt(props.applicant.documenttype, 10) !== 99 &&
              submitted &&
              !props.applicant.dateofissue && (
                <FormHelperText error id="name-error-text">
                  {' '}
                  Поле обов 'язкове
                </FormHelperText>
              )}{' '}
          </div>{' '}
        </Grid>{' '}
        {parseInt(props.applicant.documenttype, 10) === 2 && (
          <Grid item xs={12} sm={6} md={2} lg={2}>
            <div className="form-item">
              <label htmlFor="expirationDate">Дата кінця дії документу </label>{' '}
              <DateInput
                className={
                  parseInt(props.applicant.documenttype, 10) !== 99
                    ? submitted && !props.applicant.d_doc_stop
                      ? 'error'
                      : ''
                    : ''
                }
                value={props.applicant.d_doc_stop}
                onChange={handleInputChange}
                name="d_doc_stop"
                type="text"
              />
              {!(submitted && !props.applicant.d_doc_stop) &&
                !valid.d_doc_stop && (
                  <FormHelperText error id="name-error-text">
                    {' '}
                    Не валідне значення поля
                  </FormHelperText>
                )}{' '}
              {parseInt(props.applicant.documenttype, 10) !== 99 &&
                submitted &&
                !props.applicant.d_doc_stop && (
                  <FormHelperText error id="name-error-text">
                    {' '}
                    Поле обов 'язкове
                  </FormHelperText>
                )}{' '}
            </div>{' '}
          </Grid>
        )}{' '}
        <Grid
          item
          xs={12}
          sm={6}
          md={parseInt(props.applicant.documenttype, 10) === 2 ? 2 : 7}
          lg={parseInt(props.applicant.documenttype, 10) === 2 ? 3 : 6}
        >
          <div className="form-item">
            <label htmlFor="issuedby">Ким видано документ </label>{' '}
            <DocCenterInput
              className={
                !([99, 4].some(item => item === parseInt(props.applicant.documenttype)))
                  ? submitted && !props.applicant.issuedby
                    ? 'error'
                    : ''
                  : ''
              }
              name="issuedby"
              value={props.applicant.issuedby}
              type="text"
              // guide={false}
              // maxLength={
              //   parseInt(props.applicant.documenttype, 10) === 2 ? '4' : '256'
              // }
              doctype={parseInt(props.applicant.documenttype)}
              onChange={handleInputChange}
            />{' '}
            {!(submitted && !props.applicant.issuedby) && !valid.issuedby && (
              <FormHelperText error id="name-error-text">
                {' '}
                Не валідне значення поля
              </FormHelperText>
            )}{' '}
            {!([99, 4].some(item => item === parseInt(props.applicant.documenttype))) &&
              submitted &&
              !props.applicant.issuedby && (
                <FormHelperText error id="name-error-text">
                  {' '}
                  Поле обов 'язкове
                </FormHelperText>
              )}{' '}
          </div>{' '}
        </Grid>{' '}
      </Grid>
      <Grid container direction="row" spacing={2}>
        <Grid item xs={12} sm={6} md={2} lg={3}>
          <div className="form-item">
            <label htmlFor="rnokpp"> РНОКПП </label>{' '}
            <PersonalIdInput
              //className={(submitted && !applicant.rnokpp) ? 'error' : ''}
              name="rnokpp"
              value={props.applicant.rnokpp}
              type="text"
              onChange={handleInputChange}
              disabled={!props.applicant.rnokpp_feature}
            />{' '}
            {submitted && !props.applicant.rnokpp && (
              <FormHelperText error id="name-error-text">
                {' '}
                Поле обов 'язкове
              </FormHelperText>
            )}{' '}
          </div>{' '}
        </Grid>{' '}
        {/* {props.applicant.rnokpp.length !== 10 && ( */}
        <Grid
          item
          xs={12}
          sm={6}
          md={3}
          lg={5}
          // style={{
          //   paddingBottom: '-25px'
          // }}
        >
          {/* <div className="form-item pl-0"> */}
          <FormControlLabel
            control={
              <Checkbox
                // value={parseInt(props.applicant.rnokpp_feature)}
                checked={props.applicant.rnokpp_feature}
                // checked={props.applicant.rnokpp.length !== 10 ? true : false}
                onChange={handleCheck}
                name="rnokpp_feature"
                style={{
                  marginLeft: '-14px'
                }}
                color="primary"
                // disabled={true}
              />
            }
            label="Ознака відмови від РНОКПП "
            className="ml-2 mt-4"
          />

          {/* </div>{' '} */}
        </Grid>
        {/*  )} */}
      </Grid>
      <Grid container direction="row" spacing={2}>
        <Grid item xs={12}>
          {/* <Button
            disabled={props.activeStep === 0}
            onClick={props.handleBack}
            className="mr-2"
          >
            Назад
          </Button> */}
          {/* <Button
            variant="contained"
            color="primary"
            onClick={props.handleNext}
            className="mr-2"
          >
            Наступна
          </Button> */}
          <Button
            variant="contained"
            color="secondary"
            // onClick={props.handleNext}
            onClick={handleSavePassport}
            // className={classes.button}
          >
            {/* Next */}
            Зберегти
          </Button>
          {/* {props.activeStep !== props.steps.length &&
                (props.completed[props.activeStep] ? (
                  <Typography variant="caption">
                    Step {props.activeStep + 1} already completed
                  </Typography>
                ) : ( */}
          {/* <Button variant="contained" color="primary" onClick={handleComplete}> */}
          {/* {props.completedSteps() === props.totalSteps() - 1
                      ? 'Finish' */}
          {/* :  */}
          {/* Complete Step */}
          {/* '} */}
          {/* </Button> */}
          {/* ))} */}
        </Grid>
      </Grid>
    </Grid>
  );
}

const mapStateToProps = state => ({
  applicant: state.applicant,
  directories: state.directories,
  application: state.application
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, { savePassport, apllicantData })(PassportData);
